const merkleDropMinterV1Abi = [
  {
    inputs: [
      {
        internalType: "contract ISoundFeeRegistry",
        name: "feeRegistry_",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "available",
        type: "uint32"
      }
    ],
    name: "ExceedsAvailableSupply",
    type: "error"
  },
  {
    inputs: [],
    name: "ExceedsMaxPerAccount",
    type: "error"
  },
  {
    inputs: [],
    name: "FeeRegistryIsZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidAffiliateFeeBPS",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidMerkleProof",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidTimeRange",
    type: "error"
  },
  {
    inputs: [],
    name: "MaxMintablePerAccountIsZero",
    type: "error"
  },
  {
    inputs: [],
    name: "MerkleRootHashIsEmpty",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockTimestamp",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      }
    ],
    name: "MintNotOpen",
    type: "error"
  },
  {
    inputs: [],
    name: "MintPaused",
    type: "error"
  },
  {
    inputs: [],
    name: "Unauthorized",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "paid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "required",
        type: "uint256"
      }
    ],
    name: "Underpaid",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "bps",
        type: "uint16"
      }
    ],
    name: "AffiliateFeeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "quantity",
        type: "uint32"
      }
    ],
    name: "DropClaimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "maxMintablePerAccount",
        type: "uint32"
      }
    ],
    name: "MaxMintablePerAccountSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "maxMintable",
        type: "uint32"
      }
    ],
    name: "MaxMintableSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "merkleRootHash",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint96",
        name: "price",
        type: "uint96"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "affiliateFeeBPS",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "maxMintable",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "maxMintablePerAccount",
        type: "uint32"
      }
    ],
    name: "MerkleDropMintCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "merkleRootHash",
        type: "bytes32"
      }
    ],
    name: "MerkleRootHashSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "affiliateFeeBPS",
        type: "uint16"
      }
    ],
    name: "MintConfigCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "MintPausedSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "fromTokenId",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "quantity",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "requiredEtherValue",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "platformFee",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "affiliateFee",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "address",
        name: "affiliate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "affiliated",
        type: "bool"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint96",
        name: "price",
        type: "uint96"
      }
    ],
    name: "PriceSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      }
    ],
    name: "TimeRangeSet",
    type: "event"
  },
  {
    inputs: [],
    name: "MAX_BPS",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "affiliate",
        type: "address"
      }
    ],
    name: "affiliateFeesAccrued",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "merkleRootHash",
        type: "bytes32"
      },
      {
        internalType: "uint96",
        name: "price",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      },
      {
        internalType: "uint16",
        name: "affiliateFeeBPS",
        type: "uint16"
      },
      {
        internalType: "uint32",
        name: "maxMintable",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "maxMintablePerAccount",
        type: "uint32"
      }
    ],
    name: "createEditionMint",
    outputs: [
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "feeRegistry",
    outputs: [
      {
        internalType: "contract ISoundFeeRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      },
      {
        internalType: "address",
        name: "affiliate",
        type: "address"
      }
    ],
    name: "isAffiliated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint32",
        name: "requestedQuantity",
        type: "uint32"
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]"
      },
      {
        internalType: "address",
        name: "affiliate",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      }
    ],
    name: "mintInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32"
          },
          {
            internalType: "uint16",
            name: "affiliateFeeBPS",
            type: "uint16"
          },
          {
            internalType: "bool",
            name: "mintPaused",
            type: "bool"
          },
          {
            internalType: "uint96",
            name: "price",
            type: "uint96"
          },
          {
            internalType: "uint32",
            name: "maxMintable",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "maxMintablePerAccount",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "totalMinted",
            type: "uint32"
          },
          {
            internalType: "bytes32",
            name: "merkleRootHash",
            type: "bytes32"
          }
        ],
        internalType: "struct MintInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "moduleInterfaceId",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "nextMintId",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "platformFeesAccrued",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint16",
        name: "feeBPS",
        type: "uint16"
      }
    ],
    name: "setAffiliateFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "setEditionMintPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint32",
        name: "maxMintable",
        type: "uint32"
      }
    ],
    name: "setMaxMintable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint32",
        name: "maxMintablePerAccount",
        type: "uint32"
      }
    ],
    name: "setMaxMintablePerAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "bytes32",
        name: "merkleRootHash",
        type: "bytes32"
      }
    ],
    name: "setMerkleRootHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint96",
        name: "price",
        type: "uint96"
      }
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32"
      }
    ],
    name: "setTimeRange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "edition",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "mintId",
        type: "uint128"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "quantity",
        type: "uint32"
      }
    ],
    name: "totalPrice",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "affiliate",
        type: "address"
      }
    ],
    name: "withdrawForAffiliate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawForPlatform",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const merkleDropMinterV1Bytecode = "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";
const MerkleDropMinterV1Config = {
  abi: merkleDropMinterV1Abi,
  bytecode: merkleDropMinterV1Bytecode
};

export { MerkleDropMinterV1Config, merkleDropMinterV1Abi };
